<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer v-if="!$route.meta.keepAlive"></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import "/assets/css/about.css";
@import "assets/css/app.css";
::-webkit-scrollbar {
  width: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue